module.exports = __webpack_public_path__ + "img/ChuvaBlack.a12484a7.svg";